import {useCardFields} from "./use-card-fields";
import {useCardOptions} from "./use-card-options";
import {useCreatePaymentMethod} from "./use-create-payment-method";
import {useCreditCardContext} from "./use-credit-card-context";

export const useCardFormHandler = (
    {
        data,
        paypal,
        ...props
    }) => {
    const {
        billing,
        cartData,
        shippingData,
        emitResponse,
        eventRegistration,
        shouldSavePayment
    } = props;

    const {
        extensions
    } = cartData;

    const needsSetupToken = extensions?.wc_ppcp?.needsSetupToken || false;

    const {
        onPaymentSetup,
        onCheckoutValidation
    } = eventRegistration;

    const {
        options
    } = useCardOptions({
        data,
        billing,
        shippingData,
        needsSetupToken,
        shouldSavePayment
    });

    useCardFields({
        data,
        paypal,
        options
    });

    useCreatePaymentMethod({
        billing,
        emitResponse,
        onPaymentSetup,
        needsSetupToken
    });
}